import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteArticle } from 'action/article'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Article deleted'
    }
  }
})

const DeleteArticle = ({ deleteArticle, article: { uuid, title }, pagination }) => {
  const handleSubmit = () => deleteArticle(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Article</a>
  )
}

DeleteArticle.propTypes = {
  article: PropTypes.object,
  deleteArticle: PropTypes.func,
  pagination: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteArticle: bindActionCreators(deleteArticle, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.article.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteArticle)
